import styled from 'styled-components';
import { Link } from 'react-router-dom';


export const VideoContainer = styled.div.attrs({
  className: 'video-container p-6 bg-gray-100 min-h-screen'
})``;

export const VideoContent = styled.div.attrs({
  className: 'video-content max-w-4xl mx-auto'
})``;

export const VideoTitle = styled.h2.attrs({
  className: 'video-title text-3xl text-center font-semibold text-gray-800 mb-4'
})``;

export const VideoWrapper = styled.div.attrs({
  className: 'video-wrapper my-6'
})``;

export const VideoElement = styled.video.attrs({
  className: 'video-element w-full h-auto'
})``;

export const NavigationButtons = styled.div.attrs({
  className: 'navigation-buttons flex justify-between mt-6'
})``;

export const NavigationButton = styled(Link).attrs({
  className: 'navigation-button px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded hover:bg-blue-600 transition-colors'
})``;

export const DisabledButton = styled.span.attrs({
  className: 'disabled-button px-4 py-2 text-sm font-medium text-gray-400 cursor-not-allowed'
})``;

export const SuggestedTitle = styled.h3.attrs({
  className: 'suggested-title text-2xl font-semibold text-gray-700 mb-6'
})``;

export const SuggestedGrid = styled.div.attrs({
  className: 'suggested-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'
})``;

export const SuggestedItem = styled.div.attrs({
  className: 'suggested-item'
})``;

export const SuggestedText = styled.div.attrs({
  className: 'suggested-text text-center mt-2'
})``;

export const SuggestedTextTitle = styled.h4.attrs({
  className: 'suggested-text-title text-lg text-gray-800'
})``;
